
export function extraConfirm(message, expectedResponse = 'yes') {
  const input = prompt(message);
  return input === expectedResponse;
}
